import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import * as React from "react";
import { useRef } from "react";
import { dobStringToDate, useTranslation } from "hhn-commons";
import { errorsType } from "../PatientGroupUtils";
import dayjs from "dayjs";

type InputDOBProps = {
  date: string;
  onDobChange: (value: string, keyboardInputValue?: string) => void;
  checkDobValidation: (value: string) => void;
  errors: errorsType;
};
export const InputDOB = ({
  date,
  onDobChange,
  checkDobValidation,
  errors,
}: InputDOBProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={tNs("dobLabel")}
        value={date ? dayjs(dobStringToDate(date)) : null}
        format={"MM/DD/YYYY"}
        onChange={(value: dayjs.Dayjs | null, context: any) => {
          onDobChange(
            value && value.isValid() ? value.format("MM/DD/YYYY") : "",
            context?.validationError || "",
          );
        }}
        maxDate={dayjs()}
        // DOB is usually typed; opening the calendar on click would take focus
        // from the field. The calendar icon still opens it.
        keepOpenDuringFieldFocus={false}
        slotProps={{
          dialog: { closeAfterTransition: false },
          textField: {
            required: true,
            slotProps: {
              htmlInput: {
                "data-testid": "from-date-picker",
              } as React.InputHTMLAttributes<HTMLInputElement>,
            },
            inputRef,
            variant: "standard",
            error: !!errors.dob,
            helperText: errors.dob ? tNs("invalidDateOfBirth") : " ",
            onBlur: (_: React.FocusEvent<HTMLInputElement>) => {
              checkDobValidation(inputRef?.current?.value ?? "");
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};
